import { useState } from "react";

const LightboxComponent = ({
  imageUrl,
  imageAlt,
}: {
  imageUrl: string | undefined;
  imageAlt: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  //   const [selectedImage, setSelectedImage] = useState(null);

  //   const images = [
  //     { id: 1, src: "/api/placeholder/400/300", alt: "Image 1" },
  //     { id: 2, src: "/api/placeholder/400/300", alt: "Image 2" },
  //     { id: 3, src: "/api/placeholder/400/300", alt: "Image 3" },
  //     { id: 4, src: "/api/placeholder/400/300", alt: "Image 4" },
  //   ];

  const openLightbox = () => {
    // setSelectedImage(image);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
    // setSelectedImage(null);
  };

  return (
    <div
      className={`border-2 border-dashed border-gray-400 rounded-md p-4 text-center relative  ${
        imageUrl ? "h-44" : "h-auto"
      }`}
    >
      {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4"> */}
      {imageUrl ? (
        <div className="absolute z-20 left-0 right-0 bottom-0 top-0 m-4">
          <div
            key={imageAlt}
            className="cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            onClick={() => openLightbox()}
          >
            <img
              src={imageUrl}
              alt={imageAlt}
              className="w-full h-20 object-cover hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="mt-4">
            <button
              // htmlFor="file-upload"
              type="button"
              onClick={() => openLightbox()}
              className="px-4 py-2 text-sm bg-transparent border border-gray-400 rounded-md text-gray-700 cursor-pointer"
            >
              view file
            </button>
          </div>
        </div>
      ) : (
        <h3 className=" my-4 text-center">File not available</h3>
      )}
      {/* </div> */}

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <div className="relative max-w-4xl mx-4">
            <button
              className="absolute -top-10 right-0 text-white p-2 hover:text-gray-300 transition-colors"
              onClick={closeLightbox}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <img
              src={imageUrl}
              alt={imageAlt}
              className="max-h-[80vh] w-auto mx-auto rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default LightboxComponent;
